import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresProjetoService } from '../../services/indicadores-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-indicadores-relacionados-edit',
  templateUrl: './detalhe-projeto-indicadores-relacionados-edit.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-relacionados-edit.component.scss']
})
export class DetalheProjetoIndicadoresRelacionadosEditComponent extends BaseFormComponent<IndicadoresProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  indicadoresList: any[];

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(private myService: IndicadoresProjetoService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    this.addSub(
      this.myService.getListIndicadoresRelacionados(this.entity?.id).subscribe({
        next: (res) => {
          this.indicadoresList = res;
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  viewIndicador(idProjeto: number, id: number) {
    this.router.navigate(['projetos', 'projeto', idProjeto, 'indicadores', id]);
  }

  viewInfo(indicador: IndicadoresProjeto) {
    if (indicador?.viewInfoActive) {
      indicador.viewInfoActive = false;
      return;
    }

    this.loading();
    this.myService.graphTable(indicador?.id).subscribe({
      next: (value) => {
        if (value) {
          indicador.chartOptions = {
            responsive: true,
          };
          indicador.chartLabels = [];
          indicador.chartData;
          indicador.chartType = 'line';
          indicador.chartMeta = [];
          indicador.chartRealizado = [];

          value.itens.forEach((item, index) => {
            if (index != 0) {
              indicador.chartLabels.push(item[0]);
              indicador.chartMeta.push(item[1]);
              indicador.chartRealizado.push(item[2]);
            }
          })

          indicador.chartData = {
            labels: indicador.chartLabels,
            datasets: [
              {
                data: indicador.chartMeta,
                label: value.itens[0][1],
                pointRadius: 5,
              },
              {
                data: indicador.chartRealizado,
                label: value.itens[0][2],
                pointRadius: 5,
              },
            ],
          };
        }
        indicador.viewInfoActive = true;
        this.loaded();
      },
      error: (err) => {
        indicador.viewInfoActive = true;
        this.msgError(err?.error?.message);
        this.loaded();
      },
    })
  }

  voltar() {
    if (this.entity?.id) {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores', this.entity?.id]);
    } else {
      this.navigation.back(['projetos', 'projeto', this.idProjeto, 'indicadores']);
    }
  }

  viewResonsavel(indicador: IndicadoresProjeto) {
    this.modalResonsavel.openModal([indicador, ...indicador?.resp_adj]);
  }

}
